import useSession from "../session/useSession";
import useValueChangeListener from "../general/useValueChangeListener";
import useAuthRequest from "../request/useAuthRequest";
import businessLocationRequest from "../../rest/request/account/businessLocationRequest";
import {request} from "../../../../res/rest/restRequest";

const useBusinessLocations = (onlyShippable=false) => {

    const { isSignedIn } = useSession();
    const {
        loading,
        error,
        result,
        sendIt
    } = useAuthRequest();

    const {
        loading: updating,
        error: updateError,
        sendIt: updateIt
    } = useAuthRequest();

    const getLocations = () => {
        if(isSignedIn) {
            sendIt(businessLocationRequest(onlyShippable).sendIt);
        }
    }

    const updateDeliveryNote = (location, note) => {
        const req = async (session) => {
            await request.model("c_bpartner_location")
                .id(location.id)
                .data({X_DeliveryNote : note})
                .put(session);
            getLocations();
        }
        updateIt(req);
    }

    useValueChangeListener(getLocations, [isSignedIn], []);

    return {
        loading: loading || updating,
        error: error || updateError,
        updateDeliveryNote,
        locations: result,
    }
}

export default useBusinessLocations;
